// TODO replace by typescript enum
export const ZONE_GENERATION_MODE_SATELLITE = 'satellite';
export const ZONE_GENERATION_MODE_UPLOAD = 'upload';

export const POLYGON_STATES = {
  // TODO replace by typescript enum
  INACTIVE: 'inactive',
  ACTIVE: 'active',
};
